const en = {
  "nav.browse": "Browse",
  "nav.mylist": "My List",
  "nav.search": "Search",
  "nav.signin": "Sign in",
  "nav.signup": "Get started",
  "nav.settings": "Settings",
  "nav.logout": "Sign out",

  "landing.hero.eyebrow": "Streaming, refined.",
  "landing.hero.title": "Series that don't shout.",
  "landing.hero.sub":
    "A small, hand-picked catalogue. No autoplay anxiety. Watch on any device. Cancel anytime.",
  "landing.cta.primary": "Start watching",
  "landing.cta.secondary": "See what's inside",

  "landing.value.curated.title": "Curated, not crammed",
  "landing.value.curated.body":
    "We pick fewer series. The ones that stay with you. Refreshed weekly.",
  "landing.value.cinematic.title": "Cinematic playback",
  "landing.value.cinematic.body":
    "Adaptive HLS, signed playback, intro skip. No DRM nags, no autoplay traps.",
  "landing.value.private.title": "Privacy-first",
  "landing.value.private.body":
    "No tracking until you opt in. We don't sell your viewing data. Ever.",

  "pricing.monthly": "Monthly",
  "pricing.yearly": "Yearly",
  "pricing.saveTwoMonths": "Save 2 months",
  "pricing.cta": "Start subscription",
  "pricing.note": "Cancel anytime from the customer portal. Test mode in v1.",

  "footer.about": "About",
  "footer.pricing": "Pricing",
  "footer.terms": "Terms",
  "footer.privacy": "Privacy",
  "footer.cookies": "Cookies",
  "footer.tagline": "© Krix. Watch carefully.",

  "auth.signin.title": "Sign in",
  "auth.signin.sub": "Welcome back.",
  "auth.signup.title": "Create your account",
  "auth.signup.sub": "Two minutes. No credit card to browse.",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.name": "Name",
  "auth.google": "Continue with Google",
  "auth.passkey": "Use a passkey",
  "auth.forgot": "Forgot your password?",
  "auth.haveAccount": "Already have an account?",
  "auth.needAccount": "New here?",

  "cookies.title": "We respect your privacy.",
  "cookies.body":
    "We need essential cookies to keep you signed in. Analytics is off by default — opt in to help us improve.",
  "cookies.accept": "Accept all",
  "cookies.reject": "Essential only",
  "cookies.customize": "Customize",

  "error.500.title": "Something broke on our end.",
  "error.500.body":
    "We've been notified. Try again in a moment — if it persists, write us at hello@krix.sayantan.cloud.",
  "error.404.title": "We can't find that page.",
  "error.404.body": "The link may be stale, or the show may have moved.",
  "error.maintenance.title": "Krix is down for a quick update.",
  "error.maintenance.body": "Back in a few minutes.",
} as const;

export default en;
export type Dictionary = typeof en;
